import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell8InchLandscape from 'public/images/tablet-shells/FireTabletsFeatureRotator_8Inch_Landscape_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
} from '../constants';

export const TABLET_8INCH_LANDSCAPE_FOS: PreviewStateConfig = {
  label: '8" Landscape',
  altText: ALT_TEXT,
  dimensions: { width: 1280, height: 800 },
  metadataZone: { top: 315, ctaTop: 573, safeZone: 65, leftMargin: 90 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 21,
        y: 315,
        width: 1238,
        height: 345,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 21, y: 315, width: 619, height: 345 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 327,
        maxHeight: 133,
        position: { x: 141, y: 360 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 141,
        y: 513,
      },
      fontSize: 18,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 400,
      maxLines: MAX_LINES,
      lineHeight: 23,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 21, y: 315, width: 1238, height: 27 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 21, y: 620, width: 1238, height: 40 },
    },
    { type: LayerType.SHELL, src: shell8InchLandscape },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
